<template>
  <v-card v-if="users">
    <v-card-title>
      {{ $t("auditor.auditPeriodAuditorForm.title") }}
    </v-card-title>

    <v-card-subtitle>
      {{ $t("auditor.auditPeriodAuditorForm.subtitle") }}
    </v-card-subtitle>

    <v-card-text>
      <v-form ref="form" v-model="valid">
        <v-select v-model="value" :items="items"></v-select>
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-btn @click="update" :disabled="value === auditor" :loading="loading" color="secondary">
        {{ $t("auditor.auditPeriodAuditorForm.update") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import AuditorsQuery from "@/gql/queries/auditor/AuditorsQuery.gql";
import UpdateAuditPeriodMutation from "@/gql/mutations/UpdateAuditPeriodMutation.gql";
import { map } from "ramda";

export default {
  props: {
    auditPeriod: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      valid: false,
      loading: false,
      value: this.auditPeriod.auditor ? this.auditPeriod.auditor.id : null,
      users: null,
    };
  },

  apollo: {
    users: {
      query: AuditorsQuery,
      fetchPolicy: "cache-and-network",
    },
  },

  computed: {
    items() {
      return [
        { text: "", value: null },
        ...map((user) => {
          return {
            text: `${user.firstname} ${user.lastname}`,
            value: user.id,
          };
        }, this.users),
      ];
    },

    auditor() {
      return this.auditPeriod.auditor ? this.auditPeriod.auditor.id : null;
    },
  },

  methods: {
    async update() {
      if (!this.$refs.form.validate()) return;

      this.loading = true;

      this.$apollo.mutate({
        mutation: UpdateAuditPeriodMutation,
        variables: {
          id: this.auditPeriod.id,
          input: {
            auditor: this.value,
          },
        },
      });

      this.loading = false;
    },
  },
};
</script>
